import { intercepted2ogpsikxxj4u0 as intercepted } from '../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl } from './CancellableContinuationImpl.mjs';
import {
  Companion_instancejy2056q2ma5w as Companion_instance,
  _Result___init__impl__xyqfz832zdzqrocazzs as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
} from '../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  toThrowable1tarb5uizt368 as toThrowable,
  toJsPromiseError2wscsct4f14gh as toJsPromiseError,
} from './Promise.js.mjs';
import { EmptyCoroutineContext_instance3dshdbvg42f79 as EmptyCoroutineContext_instance } from '../../../kotlin-kotlin-stdlib/kotlin/coroutines/CoroutineContextImpl.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { CoroutineStart_DEFAULT_getInstance3qi77grrvmsn3 as CoroutineStart_DEFAULT_getInstance } from './CoroutineStart.mjs';
import { asyncz02dsa2nb2zt as async } from './Builders.common.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *await_0(_this__u8e3s4, $completion) {
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  return yield () => {
    var uCont = $completion;
    var cancellable = new (CancellableContinuationImpl())(intercepted(uCont), 1);
    cancellable.initCancellability_shqc60_k$();
    var cont = cancellable;
    var tmp = (it) => {
      // Inline function 'kotlin.coroutines.resume' call
      var this_0 = cont;
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$5 = _Result___init__impl__xyqfz8(it);
      this_0.resumeWith_rk9gbt_k$(tmp$ret$5);
      return null;
    };
    _this__u8e3s4.then(tmp, (it) => {
      var tmp0 = cont;
      // Inline function 'kotlin.coroutines.resumeWithException' call
      // Inline function 'kotlin.Companion.failure' call
      var exception = toThrowable(it);
      var tmp$ret$7 = _Result___init__impl__xyqfz8(createFailure(exception));
      tmp0.resumeWith_rk9gbt_k$(tmp$ret$7);
      return null;
    });
    return cancellable.getResult_fck196_k$();
  };
}
function promise(_this__u8e3s4, context, start, block) {
  context = context === VOID ? EmptyCoroutineContext_instance : context;
  start = start === VOID ? CoroutineStart_DEFAULT_getInstance() : start;
  return asPromise(async(_this__u8e3s4, context, start, block));
}
function asPromise(_this__u8e3s4) {
  var promise = new Promise((resolve, reject) => {
    _this__u8e3s4.invokeOnCompletion_n6cffu_k$((it) => {
      var e = _this__u8e3s4.getCompletionExceptionOrNull_snuvbb_k$();
      var tmp;
      if (!(e == null)) {
        tmp = reject(toJsPromiseError(e));
      } else {
        tmp = resolve(_this__u8e3s4.getCompleted_nczk2z_k$());
      }
      return Unit_instance;
    });
    return Unit_instance;
  });
  // Inline function 'kotlin.js.toJsReference' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  promiseSetDeferred(promise, _this__u8e3s4);
  return promise;
}
function promiseSetDeferred(promise, deferred) {
  promise.deferred = deferred;
  return Unit_instance;
}
//region block: exports
export {
  await_0 as awaitxmqwgrq6yfmw,
  promise as promise1ky6tawqaxbt4,
};
//endregion

//# sourceMappingURL=Promise.mjs.map
